<template>
<div>    
    <div v-if="this.$store.getters.Loaded && this.$store.getters.GetBlock.deadlines" class="uk-container uk-container-center uk-text-center uk-margin-top uk-position-z-index-negative" style="background-image: none;">
        <div v-if="this.$store.getters.GetBlock.notifications"></div>
        <h1 class="uk-heading uk-margin-top" id="date">{{this.$store.getters.GetText.deadlines.title[this.$store.getters.Lang]}}</h1>
        <div class="uk-container uk-padding uk-position-z-index-negative">
            <div class="uk-timeline uk-position-z-index-negative">
                <div v-for="item in this.$store.getters.Deadlines" :key="item.id">                    
                    <div class="uk-timeline-item uk-position-z-index-negative " uk-scrollspy="cls:uk-animation-slide-right">
                    <div class="uk-timeline-icon">                        
                            <span v-if="item.finished" class="uk-badge" uk-icon="check"></span>
                            <span v-else-if="item.timer" class="uk-badge" uk-icon="calendar"></span>
                            <span v-else class="uk-badge" uk-icon="future"></span>                        
                    </div>
                    <div class="uk-timeline-content">
                        <div class="uk-card uk-card-default uk-margin-medium-bottom uk-overflow-auto">
                            <div class="uk-card-header">
                                <div class="uk-grid-small uk-flex-middle" uk-grid>
                                    <h3 class="uk-card-title"><time datetime="{{item.date}}">{{item.title[this.$store.getters.Lang]}}</time></h3>
                                    <span  v-if="item.timer" class="uk-label uk-label-default uk-margin-auto-left">{{item.status[this.$store.getters.Lang]}}</span>
                                    <span  v-else  class="uk-label uk-label-warning uk-margin-auto-left">{{item.status[this.$store.getters.Lang]}}</span>
                                </div>
                            </div>
                            <div class="uk-card-body">                                
                                <div v-html="item.annatations[this.$store.getters.Lang]"></div> 
                                <div v-if="item.timer" id="timer">
                                    <span>{{this.$store.getters.GetText.deadlines.timer_title[this.$store.getters.Lang]}}</span><br>
                                    <div class="uk-flex-inline">
                                        <span style="font-size: 2em" class="uk-countdown-number uk-countdown-days"></span><br>
                                        <span v-if="this.timer_labels" class="uk-countdown-label uk-margin-small uk-text-center uk-visible@s">{{this.$store.getters.GetText.deadlines.timer_d[this.$store.getters.Lang]}}</span>
                                    </div>
                                    <span style="font-size: 2em" class="uk-countdown-separator">:</span>
                                    <div class="uk-flex-inline">
                                        <span style="font-size: 2em" class="uk-countdown-number uk-countdown-hours"></span><br>
                                        <span v-if="this.timer_labels" class="uk-countdown-label uk-margin-small uk-text-center uk-visible@s">{{this.$store.getters.GetText.deadlines.timer_h[this.$store.getters.Lang]}}</span>
                                    </div>
                                    <span style="font-size: 2em" class="uk-countdown-separator">:</span>
                                    <div class="uk-flex-inline">
                                        <span style="font-size: 2em" class="uk-countdown-number uk-countdown-minutes"></span><br>
                                        <span v-if="this.timer_labels" class="uk-countdown-label uk-margin-small uk-text-center uk-visible@s">{{this.$store.getters.GetText.deadlines.timer_m[this.$store.getters.Lang]}}</span>
                                    </div>
                                    <span style="font-size: 2em" class="uk-countdown-separator">:</span>
                                    <div class="uk-flex-inline">
                                        <span style="font-size: 2em" class="uk-countdown-number uk-countdown-seconds"></span><br>
                                        <span v-if="this.timer_labels" class="uk-countdown-label uk-margin-small uk-text-center uk-visible@s">{{this.$store.getters.GetText.deadlines.timer_s[this.$store.getters.Lang]}}</span>
                                    </div>

                                </div>                                 
                            </div>
                            
                        </div>
                    </div>
                    </div>

                    <!-- fin -->
                </div>
            </div>
        </div>
    </div>
</div>   
</template>

<script>

import UIkit from 'uikit'




export default {
  name: 'GeneralDate',  
  data(){    
    return{ 
        test:false,
        timer_labels:true,
        update: this.$store.getters.Loaded,     
        timer: '',
        init: false,
        b1: true     
    }    
  },
  methods:{
    initCountdown() {        
        this.timer=UIkit.countdown('#timer', this.$store.getters.TimerDate)    
    }
  },
  created(){
    this.initCountdown()
  },
  beforeMount(){
    this.initCountdown()
  },
  mounted(){
    this.initCountdown()
  },
  beforeUpdate(){
    this.initCountdown()
  },
  updated(){ 
    this.initCountdown()
  }
  
  }
</script>
<style scoped>
.uk-container .uk-timeline .uk-timeline-item .uk-card {
    max-height: unset;
}
</style>
